import logo from "./logo.svg";
import "./App.css";
import Demo from "./Components/Pass/Demo";
import Fail from "./Components/Failuer/Fail";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter,
  Routes,
  Link,
} from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import DemoDonation from "./Components/Pass/DemoDonation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Demo />} />
          <Route path="/pass" element={<Demo />} />
          <Route path="/donation" element={<DemoDonation />} />
          <Route path="/fail" element={<Fail />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
